export default __webpack_public_path__ + "static/6_28-1--780f04a8ca3b4dde12adceaf985cfa9b.png";